import $ from "jquery";

class FlexibleContent {
	constructor() {
		this.init();
	}

	init() {
		this.dom();
		this.events();
	}

	dom() {
		// Global
		this.$document = $(document);
		this.$window = $(window);
		this.$body = $('body');

		//Flexible wrap
		this.$hasFlexibleWraps = $('.has-flexible-wrap');
	}

	events() {
        this.$window.off('resize.FlexibleWrap');
        this.$window.on('resize.FlexibleWrap', this.flexibleResizeHandler.bind(this));

        this.flexibleResizeHandler();
    }

	flexibleResizeHandler() {
        this.$hasFlexibleWraps.each((i) => {
            const windowWidth = this.$window.width();
            const $hasFlexibleWrap = this.$hasFlexibleWraps.eq(i);
            const $flexibleWrap = $hasFlexibleWrap.find('.flexible-wrap');

			//Scrollbar width
			const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

            if($flexibleWrap.hasClass('flexible-wrap-bottom') && windowWidth > 768 - scrollBarWidth) {
                $hasFlexibleWrap.css({'padding-bottom': $flexibleWrap.outerHeight() + 'px'})
            } else {
                $hasFlexibleWrap.css({'padding-bottom': ''})
            }
        });
	}


}

export default FlexibleContent;
